import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SPORTS } from 'src/app/sports';
import { LocalisationService } from 'src/app/localisation.service';
import { BlockConfigService } from 'src/app/block-config.service';
import { BlockConfigurationObject } from 'src/app/block-configuration-object.model';

@Component({
  selector: 'app-upcoming-matches-list',
  templateUrl: './upcoming-matches-list.component.html',
  styleUrls: ['./upcoming-matches-list.component.scss']
})
export class UpcomingMatchesListComponent implements OnInit {
  private _sportCode: string;

  sidebarConfig: BlockConfigurationObject = null;
  
  @Input()
  set sportCode(val: string) {
    this._sportCode = val;


    this.initialiseUpcomingComponent();
  }

  constructor(private blockConfig: BlockConfigService, private localisationService: LocalisationService) { }

  ngOnInit(): void {
    this.initialiseUpcomingComponent();
  }

  initialiseUpcomingComponent(): void {
    if (typeof document !== "undefined") {


      this.activateSidebarBlock();
    }
  }

  activateSidebarBlock(): void {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      this.sidebarConfig = {
        ...this.blockConfig.getGlobalBlockConfig(),
        sports: this._sportCode ? [this._sportCode] : this.localisationService.sportPrioritySort(SPORTS).map(s => s.code),
      };
    }
		
	}

}
